import { getStoryBySlug } from '@cinch-nx/data-storyblok'
import type { GetStaticPropsContext, InferGetStaticPropsType } from 'next'
import { PartnershipsStoryContent } from './types/partnerships-page'
import { setTag, tagError } from '@core/datadog-server'

export async function getStaticProps({
  preview = false,
}: GetStaticPropsContext) {
  try {
    const story = await getStoryBySlug<PartnershipsStoryContent>(
      'partnerships',
      {
        version: preview ? 'draft' : 'published',
      },
    )

    if (!story) {
      throw new Error('Unable to fetch `partnerships` story from storyblok')
    }

    const HeroProps = story.content?.Hero?.[0]

    setTag('response.code', 200)
    setTag('page.name', 'partnerships')
    setTag('page.rendered', 'ISR')
    setTag(
      'page.params',
      JSON.stringify(
        {
          preview,
        },
        null,
        2,
      ),
    )

    return {
      props: {
        story,
        preview,
        generatedAt: Date.now(),
        layoutProps: {
          heroProps: HeroProps,
          showBorderRadius: true,
        },
      },
      revalidate: 300, // In seconds
    }
  } catch (error) {
    if (typeof error === 'string' || error instanceof Error) {
      tagError(error)
    }

    return {
      props: {
        story: null,
        preview,
        generatedAt: Date.now(),
        layoutProps: {
          heroProps: [],
          showBorderRadius: true,
        },
      },
      revalidate: 300, // In seconds
    }
  }
}

export type PartnershipsFeatureProps = InferGetStaticPropsType<
  typeof getStaticProps
>
